// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { KeywordInfoResponseDTO } from "../../api/backend-openapi";

export const setKeywords = createEvent<KeywordInfoResponseDTO[]>(
  "SET_KEYWORDS"
);
export const addKeyword = createEvent<KeywordInfoResponseDTO>("ADD_KEYWORD");
export const deleteKeyword = createEvent<string>("DELETE_KEYWORD");
export const updateKeyword = createEvent<KeywordInfoResponseDTO>(
  "UPDATE_KEYWORD"
);
